import { Link } from 'react-router-dom';
import { Logo } from '../Logo';

const COLUMNS = [
  {
    title: 'Product',
    links: [
      { to: '/how-it-works', label: 'How It Works' },
      { to: '/features', label: 'Features' },
      { to: '/industries', label: 'Industries' },
      { to: '/pricing', label: 'Pricing' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: '/about', label: 'About' },
      { to: '/trust', label: 'Trust Centre' },
      { href: 'mailto:support@shiftcover365.co.uk', label: 'Contact' },
    ],
  },
  {
    title: 'Get started',
    links: [
      { to: '/register?role=manager', label: 'Start Free Trial' },
      { to: '/register?role=worker', label: 'Sign up as a worker' },
      { to: '/login', label: 'Sign In' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/help', label: 'Help & Legal' },
      { to: '/trust', label: 'Privacy & Security' },
    ],
  },
];

export default function MarketingFooter() {
  return (
    <footer className="bg-[#0B132B] text-slate-300" data-testid="marketing-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2.5" data-testid="footer-home-link">
              <Logo linkTo={null} variant="light" />
            </Link>
            <p className="mt-5 text-[14px] text-slate-400 leading-relaxed max-w-[240px]">
              Trusted shift cover for customer-facing businesses.
            </p>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <p className="text-[11.5px] font-bold uppercase tracking-[0.18em] text-slate-500 mb-5">
                {col.title}
              </p>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.href ? (
                      <a
                        href={l.href}
                        className="text-[14.5px] text-slate-300 hover:text-white transition-colors"
                      >
                        {l.label}
                      </a>
                    ) : (
                      <Link
                        to={l.to}
                        className="text-[14.5px] text-slate-300 hover:text-white transition-colors"
                      >
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-[13px] text-slate-500">
            © {new Date().getFullYear()} ShiftCover365. All rights reserved.
          </p>
          <p className="text-[13px] text-slate-500">
            Made with care in the UK.
          </p>
        </div>
      </div>
    </footer>
  );
}
